export default __webpack_public_path__ + "static/Kalam-Bold-45ca81e00e32ef4a71e70d14775fef7a.woff2";